export default function domEvent(eventName: string) {
    const event = new Event(eventName);
    document.dispatchEvent(event);
};
